import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Which tier the page is showing.
 *
 * This used to be two pieces of state — a `selected` flag on each plan (driving
 * the highlight) and a separate `selectedplan` index (driving the description).
 * Only the flag was seeded from navigation state, so arriving from a fund that
 * is already on the commission plan highlighted «کارمزدی» while the body still
 * described «رایگان», and the bottom button disappeared entirely. One value now
 * drives all three.
 *
 * Resolution order: whatever the caller navigated with, else the fund's current
 * package once it loads. Stays `null` until one of those is known, so the page
 * can hold the description area rather than flashing the wrong tier.
 */
export default function useSetPlan(currentServicePackage?: number) {
    const { state } = useLocation()
    const navigatedPackage: number | undefined = state?.servicePackage

    const [selected, setSelected] = useState<number | null>(
        navigatedPackage ?? null
    )

    useEffect(() => {
        // Only ever fills the initial value — a click, or an earlier
        // resolution, is never overwritten by a later refetch.
        if (selected === null && currentServicePackage) {
            setSelected(currentServicePackage)
        }
    }, [currentServicePackage, selected])

    return { selected, selectPlan: setSelected }
}
